/**
 * Display US phone numbers as (XXX) XXX-XXXX.
 * Strips non-digits first so values already formatted (or masked) by the backend are not mangled
 * by slicing fixed string positions.
 */
const formatPhone = (phone) => {
    if (phone == null) return ''
    const s = String(phone).trim()
    if (s === '') return ''

    const digits = s.replace(/\D/g, '')

    if (digits.length === 10) {
        return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6, 10)
    }

    if (digits.length === 11 && digits[0] === '1') {
        const d = digits.slice(1)
        return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6, 10)
    }

    // Not 10-digit US after normalization: keep original (masks, international, partial numbers).
    return s
}

export default formatPhone
